import { TagDetailsFormController } from '../controller/TagDetailsFormController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { TagActionContext } from '../../types/TagActionContext';
import { Company, TagData } from '../../../types/tag-data';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import _ from 'lodash';
import { DeepPartial } from 'typeorm';
import { TagType } from '../../../types/tag-types';

export class TagDetailsFormWebComponent extends BaseWebComponentElement {
  public controller!: TagDetailsFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TagDetailsFormController,
    });
  }

  public get formContext(): TagActionContext {
    const context = this.getAttribute('context');

    if (!TagActionContext.isValid(context)) {
      throw new Error(`TagDetailsForm context not valid: ${context}`);
    }

    return context as TagActionContext;
  }

  public set formContext(context: TagActionContext) {
    this.setAttribute('context', context);
  }

  public get companyId(): string | null {
    return this.getAttribute('companyId');
  }

  public set companyId(companyId: string| null) {
    if (typeof companyId === "string") {
      this.setAttribute('companyId', companyId);
    } else {
      this.removeAttribute('companyId');
    }
  }

  public setCompany(company: Company) {
    this.controller?.setCompany(company);
  }

  public async setTagData(tag: TagData) {
    await this.controller.view.setTagData(tag);
  }

  public get valid$(): Observable<boolean> {
    return combineLatest([
      this.controller.view.formGroup.valid$,
      this.controller.view.dom.$tagTypeFormField.valid$,
    ]).pipe(
      map(([formGroupValid, tagTypeValid]) => {
        return formGroupValid && tagTypeValid;
      })
    );
  }

  public get value(): DeepPartial<TagData> {
    const tagType = this.controller.view.dom.$tagTypeFormField.value as TagType;
    const baseTagRecord: DeepPartial<TagData> = {
      type: tagType,
    };
    return _.merge(baseTagRecord, this.controller.view.formGroup.value);
  }
}
